var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4797",
    "data-name": "Group 4797",
    transform: "translate(-980 -967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-api-4847523",
    transform: "translate(972 955.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13092",
    "data-name": "Path 13092",
    d: "M28.5,15h-17A1.5,1.5,0,0,0,10,16.5V31a1.5,1.5,0,0,0,1.5,1.5h17A1.5,1.5,0,0,0,30,31V16.5A1.5,1.5,0,0,0,28.5,15Zm-17,1h17a.5.5,0,0,1,.5.5V18H11V16.5A.5.5,0,0,1,11.5,16Zm17,15.5h-17A.5.5,0,0,1,11,31V19H29V31A.5.5,0,0,1,28.5,31.5ZM27,17a.5.5,0,1,1,.5.5A.5.5,0,0,1,27,17Zm-1.5,0a.5.5,0,1,1,.5.5A.5.5,0,0,1,25.5,17ZM24,17a.5.5,0,1,1,.5.5A.5.5,0,0,1,24,17Zm1.1,7.9a.5.5,0,0,1,0,.707l-2,2A.5.5,0,0,1,22.4,26.9l1.646-1.646L22.4,23.6A.5.5,0,0,1,23.1,22.9ZM17.6,23.6,15.957,25.25,17.6,26.9a.5.5,0,1,1-.707.707l-2-2a.5.5,0,0,1,0-.707l2-2a.5.5,0,0,1,.707.707Zm3.861-.668-2,5A.5.5,0,0,1,19,28.25a.494.494,0,0,1-.186-.036.5.5,0,0,1-.278-.65l2-5a.5.5,0,1,1,.928.372Z",
    fill: "#212a42"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1371",
    "data-name": "Rectangle 1371",
    width: 24,
    height: 24,
    transform: "translate(980 967)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiLogo);
export default __webpack_public_path__ + "static/media/api-logo.ea5dd2d1a51e27b1d7d3953a856d43a1.svg";
export { ForwardRef as ReactComponent };